module.exports = __webpack_public_path__ + "img/architecture1.659e0b5a.jpg";